module.exports = __webpack_public_path__ + "images/emoji/dragon.1a142507e5a4b7066c91.png";